import { render } from "./videoModal.vue?vue&type=template&id=649b420b&scoped=true"
import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"

import "./videoModal.vue?vue&type=style&index=0&id=649b420b&scoped=true&lang=css"
import "./videoModal.vue?vue&type=style&index=1&id=649b420b&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649b420b"]])

export default __exports__